const BEACON_ID = "f1012ab0-3e57-4432-99f4-e08864fdfe60";
const BEACON_SCRIPT_URL = "https://beacon-v2.helpscout.net";

type BeaconMethod = (
  method: string,
  options?: unknown,
  data?: unknown,
) => void;

type QueuedBeaconMethod = BeaconMethod & {
  readyQueue: Array<{
    method: string;
    options?: unknown;
    data?: unknown;
  }>;
};

declare global {
  interface Window {
    Beacon?: BeaconMethod;
  }
}

let initialized = false;

const loadBeaconScript = () => {
  if (window.Beacon) return;

  const beacon = ((
    method: string,
    options?: unknown,
    data?: unknown,
  ) => {
    beacon.readyQueue.push({ method, options, data });
  }) as QueuedBeaconMethod;

  beacon.readyQueue = [];
  window.Beacon = beacon;

  const script = document.createElement("script");
  script.type = "text/javascript";
  script.async = true;
  script.src = BEACON_SCRIPT_URL;

  const firstScript = document.getElementsByTagName("script")[0];
  firstScript?.parentNode?.insertBefore(script, firstScript);
};

export const initializeHelpScoutBeacon = () => {
  if (initialized || typeof window === "undefined") return;

  loadBeaconScript();
  window.Beacon?.("config", { display: { style: "manual" } });
  window.Beacon?.("init", BEACON_ID);
  initialized = true;
};

export const openHelpScoutBeacon = () => {
  initializeHelpScoutBeacon();
  window.Beacon?.("open");
};
